import { render, staticRenderFns } from "./Greeter.vue?vue&type=template&id=178ea664&scoped=true"
import script from "./Greeter.vue?vue&type=script&lang=js"
export * from "./Greeter.vue?vue&type=script&lang=js"
import style0 from "./Greeter.vue?vue&type=style&index=0&id=178ea664&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178ea664",
  null
  
)

export default component.exports